import type { ControllerFetchOptions } from '~/features-shared/content/api/interfaces/params'
import type { IContent } from '~/features-shared/content/interfaces/content'
import { ServiceFetchControllerDefault } from '~/features-shared/content-feed/controllers/services-fetch-controller-default'

export class ServiceFetchControllerDrafts extends ServiceFetchControllerDefault<IContent> {
  shouldFetchFromExalead(options: ControllerFetchOptions) {
    if (options.forceExalead)
      return true

    if (options.refine?.length)
      return true

    const query = options.query?.trim()
    if (query?.length && query !== '#all')
      return true

    return false
  }
}
